import { message } from "antd";
import axiosInstance from "../../helpers/axios";
import { responseDataFormate } from "../../helpers/bycrypt";
import { API_URL } from "../../helpers/utils";

interface GetTimeOffTypesParams {
  params?: any;
  onSuccess?: (data: any[], total?: number) => void;
  onError?: () => void;
}

export const getTimeOffTypesAPI =
  ({ params, onSuccess, onError }: GetTimeOffTypesParams = {}) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/time-off-types`, { params });
      let result = responseDataFormate(response.data);
      if (result?.success) {
        onSuccess?.(result.data || [], result?.metaData?.total || 0);
      } else {
        message.error(result?.message || "Failed to fetch time off types");
        onError?.();
      }
    } catch (error: any) {
      console.error("Fetch time off types error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to fetch time off types";
      message.error(errorMessage);
    }
  };

interface CreateTimeOffTypeParams {
  payload: {
    name: string;
    type: "deductible" | "non-deductible";
  };
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const createTimeOffTypeAPI =
  ({ payload, onSuccess, onError }: CreateTimeOffTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/time-off-types`, payload);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        message.success(result?.message || "Time off type created successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to create time off type");
        onError?.();
      }
    } catch (error: any) {
      console.error("Create time off type error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to create time off type";
      message.error(errorMessage);
    }
  };

interface UpdateTimeOffTypeParams {
  id: string;
  payload: {
    name: string;
    type: "deductible" | "non-deductible";
  };
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const updateTimeOffTypeAPI =
  ({ id, payload, onSuccess, onError }: UpdateTimeOffTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/time-off-types/${id}`, payload);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        message.success(result?.message || "Time off type updated successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to update time off type");
        onError?.();
      }
    } catch (error: any) {
      console.error("Update time off type error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to update time off type";
      message.error(errorMessage);
    }
  };

interface DeleteTimeOffTypeParams {
  id: string;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const deleteTimeOffTypeAPI =
  ({ id, onSuccess, onError }: DeleteTimeOffTypeParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete(`${API_URL}/time-off-types/${id}`);
      let result = responseDataFormate(response.data);
      if (result?.success) {
        message.success(result?.message || "Time off type deleted successfully");
        onSuccess?.(result.data);
      } else {
        message.error(result?.message || "Failed to delete time off type");
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete time off type error:", error);
      onError?.();
      const errorMessage =
        error?.response?.data?.message || "Unable to delete time off type";
      message.error(errorMessage);
    }
  };
